import React, { Suspense } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import VideoList from './components/VideoList';
import Layout from './components/layout/Layout';
import Login from './pages/Login';
import AdminContent from './pages/AdminContent';
import NotFound from './pages/NotFound';
import Unauthorized from './pages/Unauthorized';
import PrivateRoute from './components/PrivateRoute';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfService from './pages/TermsOfService';
import HelpSupport from './pages/HelpSupport';
import AppDownload from './pages/AppDownload';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/admin/login" element={<Login />} />
        <Route path="/*" element={
          <Layout>
            <Suspense fallback={<div style={{ color: '#fff', padding: 20 }}>Cargando...</div>}>
              <Routes>
                <Route path="/" element={<VideoList />} />
                <Route path="/politica-privacidade" element={<PrivacyPolicy />} />
                <Route path="/termos-uso" element={<TermsOfService />} />
                <Route path="/ajuda-suporte" element={<HelpSupport />} />
                <Route path="/como-baixar-app" element={<AppDownload />} />
                <Route path="/admin/content" element={<PrivateRoute><AdminContent /></PrivateRoute>} />
                <Route path="/unauthorized" element={<Unauthorized />} />
                <Route path="*" element={<NotFound />} />
              </Routes>
            </Suspense>
          </Layout>
        } />
      </Routes>
    </Router>
  );
}

export default App;
